import type { DomApplier } from '../cssFeatures.types'
import { assign } from 'lodash'

export const meshDomApplier: DomApplier<'mesh'> = (_component, __, _breakpointId, { mesh }, accumulatedData) => {
	if (!mesh || !mesh.meshResults) {
		return {}
	}

	const output = mesh.meshResults.reduce(
		(stylesMap, meshResult) =>
			assign(stylesMap, accumulatedData.isInRepeater ? meshResult.repeaterStylesMap : meshResult.stylesMap),
		{}
	)
	return output
}
